import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const railAtom = atomWithStorage('ui.rail', false, undefined, {
  getOnInit: true,
});

export const useRail = () => useAtom(railAtom);
